export class DashboardParams {
    filterSelected: string = 'week';
    applicationResponseFilter = 'min';
}

export class GraphDataValue {
    labels = [];
    dataset: DatasetValue[] = [];
}

export class DatasetValue {
    label: string = '';
    data = [];
}